import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-documents-tooltip-icon',
  templateUrl: './documents-tooltip-icon.component.html',
  styleUrls: ['./documents-tooltip-icon.component.scss']
})
export class DocumentsTooltipIconComponent implements OnInit {
  @Input() documents: string[];
  @Input() fallbackDocumentsTranslations: object;

  constructor() {}

  ngOnInit() {}
}
